<template>
  <div v-if="entry" class="provider-field-discrepancy">
    <v-chip
      size="small"
      variant="tonal"
      label
      :color="entry.status === 'conflict' ? 'warning' : 'info'"
      prepend-icon="mdi-alert-circle-outline">
      <template v-if="entry.status === 'conflict'">Address book has: {{ entry.rosterValue }}</template>
      <template v-else>Not yet in your address book</template>
    </v-chip>
    <v-btn
      size="small"
      variant="tonal"
      :color="entry.status === 'conflict' ? 'warning' : 'info'"
      prepend-icon="mdi-check"
      :loading="loading"
      @click="emit('apply', field)">
      {{ entry.status === "conflict" ? "Update address book" : "Add to address book" }}
    </v-btn>
    <v-alert v-if="error" density="compact" variant="tonal" color="error" icon="mdi-alert-outline" role="alert">
      {{ error }}
    </v-alert>
  </div>
</template>

<script setup>
defineProps({
  field: { type: String, required: true },
  entry: { type: Object, default: null },
  loading: { type: Boolean, default: false },
  error: { type: String, default: null },
});

const emit = defineEmits(["apply"]);
</script>

<style scoped>
/* Positive top margin (not the field's negative-margin convention used elsewhere) so this never
   stacks on top of the input's own error-messages slot when both are shown at once. */
.provider-field-discrepancy {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  margin-bottom: 8px;
}
</style>
